import React from "react";
import PageHeader from "../PageHeader/PageHeader";
import classes from "./About.module.css";
import Me from "../../img/Me.jpg";
function About() {
  return (
    <div className={classes.AboutMe} id="about">
      <PageHeader title={"About Me"} />
      <div className={classes.Container}>
        <div className={classes.Text}>
          <h2>Hello!, I'm Sachin Koli</h2>
          <p>I'm a software developer based in the India.and I've done my BE from Mumbai University(2016-2020) in Electrical Engg. I am passionate about creating new code solutions for the problems and improving my skills. I have knowledge about frontend and I'm interested in MERN Stack in which I'd like to pursue my career in.
          </p>
        </div>
        <div className={classes.Photo}>
          <img className={classes.Me} alt="me" src={Me}></img>
        </div>
      </div>
    </div>
  );
}

export default About;
